<template>
  <div :class="$style.container" @click="goToSms">
    <img :src="message.prospect.photoUrl || defaultAvatar" :class="$style.avatar" />
    <div :class="$style.messagePreview">
      <p :class="$style.prospectName">{{prospectName}}</p>
      <p :class="$style.message">{{messagePreview}}</p>
    </div>
    <p :class="$style.date">{{messageDate}}</p>
  </div>
</template>

<script>
  import moment from 'moment'
  import defaultAvatar from '@/assets/img/default-avatar.svg'

  export default {
    props: [
      'message'
    ],
    data () {
      return {
        defaultAvatar
      }
    },
    computed: {
      prospectName () {
        return this.message.prospect.prospectName
          ? this.message.prospect.prospectName
          : this.message.prospect.phoneNumberFormatted
      },
      knownProspect () {
        return !!this.message.prospect.prospectId
      },
      messagePreview () {
        return this.message.direction === 'inbound'
          ? `${this.prospectName}: ${this.message.body}`
          : `You: ${this.message.body}`
      },
      messageDate () {
        return moment(this.message.timestamp).format('L')
      }
    },
    methods: {
      goToSms () {
        this.$router.push({
          path: 'phone-controller',
          query: {
            type: encodeURIComponent('JIMINNY.SMS'),
            phone: encodeURIComponent(this.message.prospect.phoneNumber),
            ...this.knownProspect && {
              recordId1: encodeURIComponent(this.message.prospect.prospectId),
              objectType: encodeURIComponent(this.message.prospect.prospectType.toLowerCase())
            }
          }
        })
      }
    }
  }
</script>

<style module lang="less" src="./message-preview.less"></style>



// WEBPACK FOOTER //
// message-preview.vue?c42c8054